import React, { useEffect, useRef, useState } from 'react';
const Grid = ({ cells, size, revealSolution = true }) => {
    const divRef = useRef(null);
    const [unit, setUnit] = useState(0);
    useEffect(() => {
        const measure = () => {
            if (divRef.current) {
                const rect = divRef.current.getBoundingClientRect();
                setUnit(Math.floor(Math.min((rect.width - 10) / size, (rect.height - 10) / size)));
            }
        };
        measure();
        window.addEventListener('resize', measure);
        return () => window.removeEventListener('resize', measure);
    }, [size]);
    return (React.createElement("div", { ref: divRef, className: "word-search-grid" }, cells.map((row, i) => (React.createElement("div", { key: i, className: "word-search-grid__row" }, row.map((cell, j) => (React.createElement("div", { key: j, className: 'word-search-cell' +
            (revealSolution && cell.isWord
                ? ' word-search-cell--solution'
                : ''), style: { width: unit, height: unit, fontSize: unit / 2 } }, cell.letter))))))));
};
export { Grid };
